// Removes a near-white background from an uploaded signature/initials scan so it
// stamps cleanly (transparent) onto the court PDF. Returns a PNG data URL.
export function removeWhiteBackground(dataUrl, threshold = 235) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = img.naturalWidth || img.width;
      c.height = img.naturalHeight || img.height;
      const ctx = c.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(img, 0, 0);
      try {
        const id = ctx.getImageData(0, 0, c.width, c.height);
        const d = id.data;
        for (let i = 0; i < d.length; i += 4) {
          if (d[i] >= threshold && d[i + 1] >= threshold && d[i + 2] >= threshold) {
            d[i + 3] = 0; // make near-white pixels transparent
          }
        }
        ctx.putImageData(id, 0, 0);
        resolve(c.toDataURL("image/png"));
      } catch {
        resolve(dataUrl); // tainted canvas / CORS — fall back to original
      }
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
}
